module.exports = __webpack_public_path__ + "img/splunk.d3970505.png";